import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from '@router/router'
import {
  store
} from '@store/store'


Vue.config.productionTip = false

// requires autentication for routes with requiresAuth parameter
router.beforeEach((to, from, next) => {
  console.log('Navigating to:', to.fullPath)
  if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!store.getters.isLoggedIn) {
          next({
              path: '/login',
              query: {
                  redirect: to.fullPath
              }
          })
      }
      next()
  } else {
      next()
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

